var _style, _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _g5, _path7, _g6, _path8, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoxyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 222.3 142.4",
    style: {
      enableBackground: "new 0 0 222.3 142.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.43;fill:url(#SVGID_00000098197220001427692960000000530662000274495882_);enable-background:new    ;}\r\n\t.st2{opacity:0.58;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:url(#SVGID_00000093156373575186153210000010930855546314399879_);}\r\n\t.st5{fill:#494064;}\r\n\t.st6{fill:url(#SVGID_00000056387682267777106390000014590363610663399828_);}\r\n\t.st7{fill:#F4C173;}\r\n\t.st8{fill:url(#SVGID_00000138545952770846352240000004079207736968608422_);}\r\n\t.st9{fill:url(#SVGID_00000070082935666463288340000018227276881166323373_);}\r\n\t.st10{fill:url(#SVGID_00000057135743110391885580000013626186486977497507_);}\r\n\t.st11{fill:#F7B032;}\r\n\t.st12{fill:#1D1E1C;}\r\n\t.st13{opacity:0.74;}\r\n\t.st14{fill:url(#SVGID_00000094595645790735163220000009215200824777643661_);}\r\n\t.st15{opacity:0.29;}\r\n\t.st16{fill:url(#SVGID_00000070110815538073904170000003015036130507736754_);}\r\n\t.st17{opacity:0.1;}\r\n\t.st18{fill:#E95835;}\r\n\t.st19{fill:url(#SVGID_00000164514538800433613070000006381715204745994422_);}\r\n\t.st20{opacity:0.5;}\r\n\t.st21{fill:#29265B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000044880637575815155720000006981360853853841296_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.3,
    y1: 529.5434,
    x2: 87.23,
    y2: 529.5434,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6DDE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.9,29.8c9.2,5.6,9.5,15,12.1,20.2C69.1,9.1,6.7,39.2,5.3,70.8c8.4-0.1,19.3-3,31.5,6.6 c9.6,8,19,15.8,30.7,15.5c-4.6,2.7-10.1,3.4-16.7,2c17.6,26.8,40.7,33.7,71,13.7c-4.5,7.4-11.3,12.7-19.6,16.7 c27-7.3,48.7-20.2,50.4-54.5c-12.1,5.9-21.6,3.6-28.8-5.7c0,3.3,1.5,6.3,4.6,9.2C128.3,74.3,88,28.9,74.9,29.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011009633943438775420000013106533234491130045_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.3,
    y1: 502.5,
    x2: 48.63,
    y2: 502.5,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6DDE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "url(#SVGID_00000011009633943438775420000013106533234491130045_)",
      enableBackground: "new"
    },
    d: " M56.7,30.2c-23.6,0-50.5,20-51.4,40.6l0,0c7.5-17.3,33.5-32.1,56.6-32.1c8.1,0,15.8,1.8,22.2,5.9C77.6,34.3,67.5,30.2,56.7,30.2 z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.5,74c-6.5,9.4-16.2,16.8-27.3,23.3c7-6,12.1-13,14.5-21.3c-23.9,27.3-20.7,34-44.8,12.8 c6.7-0.4-8.7-13.3-21.5-17.6c-9,0.2-22.2-2.4-26.4-3.7c-14.8-4.4-21.5,0.6-29.6,2.9c0,0.1,0,0.2,0,0.2c8.4-0.1,19.3-3,31.5,6.6 c9.6,8,19,15.8,30.7,15.5c-4.6,2.7-10.1,3.4-16.7,2c17.6,26.8,40.7,33.7,71,13.7c-4.5,7.4-11.3,12.7-19.6,16.7 c27-7.3,48.7-20.2,50.4-54.5C148.1,72.9,144.1,73.9,140.5,74L140.5,74z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093177112786656341120000007459674068777947042_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.8,
    y1: 526.5175,
    x2: 135.4,
    y2: 526.5175,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B032"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4342A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093177112786656341120000007459674068777947042_)"
    },
    d: "M47.8,86c0,0,12.6,3.9,24.5,3.6 c0,0-4.9-14.2-11-18.3c0,0,15.4-0.2,20,5.6c0,0-5.3-16-14.7-20.2c0,0,11.9-5.6,18.9,9.1c0,0-3.3-19-18.8-26.2 c0,0,13-0.2,20.4,10.3l0,0c-1-3.4-5.8-15.3-12.1-20.2c0,0,7.3,1.1,21,13.5c17.3,15.9,19.7,18.4,22.4,20.6s17.1,48,17.1,48 c-46.1,9.9-54.9,11.1-72.6-2.8c0,0-6.6-5.2-11.9-14.3c0,0,10.2,1.8,16.7-2C67.5,92.9,57.5,93.5,47.8,86L47.8,86z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.1,127.1c-0.7,0-1.4-0.4-1.7-1.2c-0.3-0.8,0.1-1.8,0.9-2.2c5.2-2.5,9.5-5.4,13-8.7 c-12,6.2-23.2,8.2-33.3,6c-11.8-2.6-22.6-11.1-31.8-25.2c-0.4-0.6-0.4-1.4,0-2s1.1-0.9,1.8-0.7c3,0.7,5.9,0.8,8.5,0.5 c-8.9-2.4-16.5-8.7-23.9-14.9c-9.6-7.6-18.2-7-25.8-6.5c-1.6,0.1-3.1,0.2-4.6,0.2c-0.5,0-0.9-0.2-1.3-0.5 c-0.3-0.3-0.5-0.8-0.5-1.3C4.3,54.5,22.3,34,48,29.2c12.7-2.4,23.7,0.3,31.6,7.3c-1.3-1.9-3.1-3.8-5.6-5.3 c-0.6-0.3-0.9-0.9-0.8-1.5c0-0.9,0.7-1.7,1.7-1.8c0.1,0,0.3,0,0.4,0c10.7,0,34.4,23.6,46.8,36.9c0.1-0.6,0.6-1.1,1.2-1.3 c0.7-0.2,1.5,0,1.9,0.6c6.9,8.9,15.6,10.6,26.6,5.2c0.6-0.3,1.2-0.2,1.7,0.1c0.5,0.3,0.8,0.9,0.8,1.6 c-1.8,37.7-27.2,49.5-51.7,56.1C102.5,127,102.3,127,102.1,127.1L102.1,127.1z M121.8,106.9c0.4,0,0.9,0.2,1.2,0.5 c0.6,0.6,0.7,1.5,0.3,2.2c-2.2,3.6-4.9,6.8-8.3,9.7c28.1-11.3,34.3-28.9,35.6-45.6c-8.1,3.3-15.3,2.9-21.4-0.9 c0.2,0.2,0.3,0.3,0.4,0.5c0.6,0.7,0.6,1.8-0.1,2.4c-0.7,0.7-1.7,0.7-2.4,0.1c-1-0.9-1.9-1.9-2.6-2.9 c-10.3-11.5-30.3-32-42.5-39.1c2.6,3.5,3.8,7.4,4.9,10.7c0.4,1.3,0.8,2.5,1.2,3.6c0.2,0.4,0.3,0.7,0.5,1.1 c0.4,0.9,0,1.9-0.9,2.3s-1.9,0.1-2.3-0.8c-0.2-0.4-0.4-0.8-0.5-1.2c-6.6-13.8-19.7-19.9-36.3-16.9C28,36.5,9.3,53.1,7.2,69 c0.8,0,1.6-0.1,2.4-0.2c7.8-0.5,17.6-1.2,28.2,7.2l0.1,0.1c9.5,7.8,18.5,15.3,29.5,15.1l0,0c0.8,0,1.5,0.5,1.7,1.3 s-0.1,1.6-0.8,2c-4,2.3-8.6,3.3-13.8,2.8c8.2,11.3,17.4,18.2,27.4,20.3c11.5,2.5,24.6-1,38.9-10.4 C121.1,107,121.4,106.9,121.8,106.9L121.8,106.9z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.3,61.6c0.7,4.2-4.4,6.5-6,7.3c-4.3,2-10.9,4.7-14.5,6.1c1.2,2.6,3.4,8.6,2.7,16.5 c0.3,2.2,0.5,4.2,0.5,6.2c0.8,18-4.9,30-17.4,36.7c-10.5,5.7-24.9,6.8-39.8,7.6c-4.3,0.2-9.3,0.4-14.1,0.4 c-11.4,0-19.8-1.3-26.3-4c-6.5-2.8-11.5-7.1-15-13.1c-1.1,0.1-2.1,0.1-3.2,0.1c-3,0-6.1-0.3-8.9-1c-12.8-2.8-24.2-11.8-34-26.7 c-1.2-1.8-1.2-4.1,0-5.9c0.1-0.1,0.2-0.2,0.3-0.3c-4.6-2.9-8.9-6.5-13.2-10c-6.7-5.3-12.6-6-17.5-6c-2,0-3.9,0.1-5.9,0.3 C8.5,75.9,6.9,76,5.4,76H5.3c-1.4,0-2.8-0.6-3.8-1.6S0,71.9,0,70.5c0.4-9,5.5-19,13.9-27.3c9-8.9,20.8-15.1,33.4-17.4 c3.2-0.6,6.5-0.9,9.5-0.9c4.8,0,9.3,0.8,13.4,2.2c0.8-1.5,2.4-2.6,4.3-2.7c0.2,0,0.4,0,0.6,0c2.2,0,5,0.8,8.1,2.4 c0.7-4.2,1.8-8.5,3.7-12.8l1.2-2.9c0.4-0.9,1.1-1.6,2.1-1.9C90.7,9,91,8.9,91.4,8.9c0.6,0,1.2,0.2,1.7,0.5l29.1,16.9 c3.2-2.1,5.6-3.6,6.1-4c1-0.7,5.6-3.9,12.9-3.9c2.9,0,6,0.5,9,1.5c2.2,0.8,4.9,1.6,8.1,2.6l25.2-21.7c0.6-0.5,1.4-0.8,2.2-0.8 c0.2,0,0.4,0,0.5,0c1,0.2,1.9,0.7,2.4,1.6l1.6,2.6c8.7,14.2,9.1,29.1,7.9,39.4c0.4,1.3,0.7,2.7,0.8,4l0.6,6.9l0.2,2.5 c4.7-0.4,8.1-0.5,10.6-0.5c1.2,0,2.3,0,3.2,0.1C215.6,56.8,221.5,57.3,222.3,61.6L222.3,61.6z M89.3,121.9c0.5,0,1,0,1.4-0.1 c-2.2-5-3.5-10.8-3.8-17.6c-1.3-4.9-2-10.4-1.9-16.5c0-1.3,0.7-2.4,1.9-3c0,0,0.1-0.1,0.2-0.1C87,84.3,87,84,87,83.7l0,0 l-2.1-25.2c0,0,0-0.1,0-0.2c0-0.3,0-1.8,0.6-3.8c-2-6.4-3.5-14.8-2.6-24.1c-2.9-1.6-5.5-2.5-7.7-2.5c-0.1,0-0.3,0-0.4,0 c-0.9,0.1-1.7,0.9-1.7,1.8c0,0.6,0.3,1.2,0.8,1.5c2.5,1.5,4.3,3.3,5.6,5.3c-6-5.3-13.8-8.1-22.7-8.1c-2.8,0-5.8,0.3-8.9,0.9 C22.3,34,4.3,54.5,3.5,70.7c0,0.5,0.2,1,0.5,1.3s0.8,0.5,1.3,0.5l0,0c1.5,0,3-0.1,4.6-0.2c2-0.1,4-0.3,6.1-0.3 c6,0,12.6,1.1,19.7,6.8c7.4,6.2,15,12.5,23.9,14.9c-0.8,0.1-1.7,0.2-2.5,0.2c-1.9,0-3.8-0.2-5.9-0.7c-0.1,0-0.2,0-0.4,0 c-0.6,0-1.1,0.3-1.5,0.8c-0.4,0.6-0.4,1.4,0,2c9.3,14.1,20,22.6,31.8,25.2C83.8,121.6,86.5,121.9,89.3,121.9L89.3,121.9z  M100.5,125.9c0.3,0.7,0.9,1.2,1.7,1.2c0.2,0,0.3,0,0.5-0.1c24.5-6.6,49.9-18.4,51.7-56.1c0-0.6-0.3-1.2-0.8-1.6 c-0.3-0.2-0.6-0.3-1-0.3c-0.3,0-0.5,0.1-0.8,0.2c-4.2,2-8,3.1-11.6,3.1c-5.8,0-10.8-2.7-15.1-8.2c-0.3-0.4-0.9-0.7-1.4-0.7 c-0.2,0-0.4,0-0.6,0.1c-0.6,0.2-1.1,0.7-1.2,1.3c-9.1-9.7-24.2-24.9-35.9-32.4c-0.6,8.5,1,16.2,2.9,22.2 c-0.9,2.1-0.8,3.6-0.8,3.6l2.2,25.3l0,0l0,0l0,0l0,0c0.1,0,0.7,0.4,1.7,0.8c-0.2,0.7-0.3,1.3-0.4,2c-2.1,0.8-3.3,1.4-3.3,1.4 c-0.1,6.6,0.7,11.9,1.9,15.9c0.3,7.1,1.7,13,4,17.9c6.4-0.8,13.1-2.9,20.1-6.6c-3.5,3.4-7.8,6.2-13,8.7 C100.5,124.1,100.1,125,100.5,125.9L100.5,125.9z M96.9,124.8c-0.2,0-0.4,0.1-0.6,0.1c0.2,0.3,0.4,0.7,0.7,1 C96.8,125.5,96.8,125.1,96.9,124.8L96.9,124.8z M214.8,65.8c6.1-2.8,5.2-5.2-1.5-5.8c-0.8-0.1-1.8-0.1-2.9-0.1 c-3.3,0-7.9,0.3-13.8,0.8c-0.4-4.1-0.7-8.6-1.1-12.8c-0.1-1.4-0.4-2.7-0.9-3.9c1.4-10.2,1-24.4-7.3-38l-1.6-2.6l-26.7,23 c-3.6-1.1-7.1-2.2-10-3.2s-5.6-1.4-7.9-1.4c-6.9,0-10.9,3.2-10.9,3.2s-3.3,2.2-8,5.2L91.4,12.4l-1.2,2.9c-1.9,4.5-3.1,9-3.7,13.2 c8.9,5.3,20.9,15.9,35.8,31.5c0.4-0.1,0.9-0.2,1.4-0.2c1.6,0,3.2,0.7,4.2,2c3.6,4.6,7.6,6.9,12.3,6.9c3,0,6.4-0.9,10.1-2.7 c0.7-0.3,1.5-0.5,2.3-0.5c1,0,2,0.3,2.9,0.9c1.6,1,2.5,2.8,2.4,4.7c-0.9,18.2-6.9,32-18.5,42.2c-10.9,9.6-24.8,14.2-35.8,17.1 c-0.4,0.1-0.9,0.2-1.4,0.2c-0.4,0-0.7-0.1-1.1-0.1c2.2,1.9,4.8,3.5,7.7,4.7c7,2.9,15.6,3.8,24.9,3.8c4.5,0,9.2-0.2,13.9-0.4 c14.6-0.7,28.5-1.8,38.4-7.2c11.2-6.1,16.3-17,15.6-33.5c-0.1-2.1-0.3-4.2-0.6-6.2c1-9.7-2.9-16.2-2.9-16.2 c-0.5-0.1-1.1-0.1-1.6-0.1c-0.2-0.4-0.3-0.8-0.5-1.1c1.2-0.7,1.8-1.2,1.9-1.3C198,72.8,208.7,68.6,214.8,65.8L214.8,65.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081648140546563977800000011101639969523536049_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.45,
    y1: 478.35,
    x2: 192.1851,
    y2: 478.35,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D86327"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D45026"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081648140546563977800000011101639969523536049_)"
    },
    d: "M176.9,35.1c4.4,1.4,9,3.2,12.5,6.6 c0.8,0.8,1.6,1.6,2.2,2.5c2.8-23.3-6.3-35.7-6.3-35.7l-25.9,21.4C165.4,31.2,171.2,33.2,176.9,35.1z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.7,32.1c7.6-9.1,16.7-20.3,16.7-20.3l-1.4-2l-23.6,19.9C162.2,30.4,164.9,31.2,167.7,32.1L167.7,32.1z "
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.6,30.6l21.8-18.8c5.5,10.5,6,21.4,5.1,29.8l0,0c1.8,1.7,3.5,3.8,4.5,6.3V48c2-10.2,2.9-26.5-6.6-42 l-1.6-2.6L156,29C158.2,29.4,160.4,30,162.6,30.6L162.6,30.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164493337366179960210000010042857736703143835_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.8162,
    y1: 488.7,
    x2: 120.82,
    y2: 488.7,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED9B26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E58826"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164493337366179960210000010042857736703143835_)"
    },
    d: "M94.6,53.5c3.1-3.7,6.8-6.9,10.6-9.8 c4.9-3.8,10.3-7,15.7-10.1L92.7,17.1c-4.9,17.3-2.7,31-0.2,39.2C93.1,55.4,93.7,54.4,94.6,53.5L94.6,53.5z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120.5,33.8L94.1,20.4l21.2,16.4C117,35.8,118.7,34.8,120.5,33.8L120.5,33.8z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.6,53.5C94.6,53.5,94.6,53.4,94.6,53.5c-2.7-8.3-4.8-20.4-0.4-33.1L119,34.7c1.9-1.1,3.7-2.1,5.6-3.2 L91.4,12.3l-1.2,2.9c-7.8,18.4-3,35.7,1,44.9C91.7,57.7,92.7,55.6,94.6,53.5L94.6,53.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054246544157050318350000007170916149857674654_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.89,
    y1: 542.3,
    x2: 199.29,
    y2: 542.3,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC9B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D45026"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054246544157050318350000007170916149857674654_)"
    },
    d: "M193.2,67.5c-1.3-2.1-2.5-4.4-3.7-6.6 c-2.9-1.5-5.8-3.9-7.5-5c-3.6-2.5-7.4-5.1-10.8-8c-1.4-0.5-2.8-1-4.2-1.5c-1.8-0.6-3.7-1.1-5.5-1.6l-3.7,2.4l-29.1,1.5l-1.8-1 c-2.1,1.1-4.1,2.3-6.1,3.5c-3.9,2.3-7.9,4.4-11.7,7c-3.9,2.5-7.2,5.4-10.2,9.1c-0.9,1.1-1.7,2.2-2.6,3.3 c0.9,2.1,1.7,3.1,1.7,3.1l-6,14.5l0.7,15.6l4,17.5l15.4,13.8l44,0.7l29.6-6.5l10.5-10.1l3.2-25.2l-7.2-23.6 C192.5,69.3,192.9,68.4,193.2,67.5L193.2,67.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119838515551929102960000017684909267798691747_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.1672,
    y1: 552.7927,
    x2: 173.6472,
    y2: 577.3827,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119838515551929102960000017684909267798691747_)"
    },
    d: "M162.8,110.1c0,0-2.3-9.3-7.6-10.5 l-8.5,19.9l-9.9-18.3c-5.1,1.7-7,10.6-7,10.6c-31-13.2-35.1,4.7-35.1,4.7l7.9,13.1l17.4,5.9l27.4,0.3l27.2-3l16.8-7.6l6.7-13.8 C198.2,111.3,192.5,93.9,162.8,110.1L162.8,110.1z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.2,70.5c0.1-0.2,0.3-0.5,0.5-0.9c-1.2-1.6-2.2-3.3-3.1-5.1c-0.1,0.4-0.3,0.8-0.4,1.1 c-2.3-3.2-4.9-6.1-7.8-8.7c-0.6-0.5-1.1-1-1.7-1.4c-0.6-0.5-1.3-0.9-2-1.4c-0.4,0.9-0.7,1.8-0.8,2.7c-0.1,0.8,0,1.6,0.1,2.4 c0.3,0.3,0.5,0.6,0.8,0.8c0.4,0.5,0.7,0.9,1,1.4c0.4,0.3,0.7,0.6,1,1c8.8,8.6,14.3,20.8,15,35.5c1.3,30.4-18.7,33.6-49.4,35.2 s-50.9,0.3-52.3-30.1c-0.7-15.8,4.4-29.5,13.7-39.1c0.5-0.9,0.9-1.9,1.2-3c0.1-0.3,0.2-0.7,0.2-1c-0.3-0.7-0.5-1.5-0.8-2.2 c-0.1,0.1-0.3,0.2-0.4,0.2c-1.8,1.2-3.5,2.5-5.2,3.9c-1.9,2.2-3.7,4.5-5.2,7c-0.2-0.3-0.3-0.6-0.5-0.9c-1.1,1.4-2.2,2.9-3.3,4.3 c0.4,0.7,0.7,1.3,1,1.8c-4.1,8.6-6,18.4-5.5,29.2c0.7,16.5,6.8,26.9,18.5,31.8c10.3,4.3,24.3,4.1,38.8,3.3s28.5-1.8,38.4-7.2 c11.2-6.1,16.3-17,15.6-33.5C201.1,87.6,198.6,78.4,194.2,70.5L194.2,70.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.7,85.8c0,0,5.7,2.3,5.2,8.6c-0.5,6.3-7.2,6.8-9,7s-8.6-0.8-7-8.3S170.7,85.1,173.7,85.8L173.7,85.8z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.710260e-02 1.710260e-02 0.9999 -1.5742 2.9349)",
    className: "st11",
    cx: 170.8,
    cy: 93.5,
    rx: 4.4,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.710260e-02 1.710260e-02 0.9999 -1.5742 2.9349)",
    className: "st12",
    cx: 170.8,
    cy: 93.5,
    rx: 2.7,
    ry: 3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.710260e-02 1.710260e-02 0.9999 -1.5522 2.9022)",
    className: "st3",
    cx: 168.9,
    cy: 92.2,
    rx: 1.4,
    ry: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.8,100C114.9,99.7,114.8,99.7,114.8,100c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.3,0.2-0.4 c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.1,0.3-0.5,0.1-0.1c0.2-0.3,0.5-0.6,0.7-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.5-0.6,0.2-0.2 c0.4-0.4,1.2-0.7,1.7-1c0.2-0.1,0.2-0.1-0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3-0.1,0.7-0.2,1.1-0.3 c0.2,0,0.3-0.1,0.5-0.1c-0.6,0,0.2,0,0.3,0c0.4,0,0.7,0,1.1,0c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0h-0.2c0.4,0,0.8,0.2,1.2,0.2 c0.4,0.1,0.8,0.2,1.1,0.4c0.2,0.1,0.2,0.1,0,0c0.1,0,0.2,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.5,0.3c0.4,0.2,0.7,0.4,1,0.6 c0.1,0.1,0.3,0.2,0.4,0.3c-0.4-0.3,0.2,0.2,0.3,0.2c0.8,0.7,2.1,0.9,2.9,0c0.7-0.8,0.9-2.2,0-2.9c-3.2-2.7-7.2-3.9-11.3-3.1 c-3.8,0.8-6.9,3.4-8.3,7c-0.4,1,0.4,2.3,1.5,2.6C113.4,101.7,114.3,101,114.8,100L114.8,100L114.8,100z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072958666183931287770000003495740394351389595_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.3965,
    y1: 548.6644,
    x2: 201.1296,
    y2: 548.6644,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#642480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1839"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072958666183931287770000003495740394351389595_)"
    },
    d: "M198.1,74.2 c-30.3-2.6-35.1,4.9-45.4,8.1s-16.8,1.8-16.8,1.8c-24.8-9.2-47.5,2.4-47.5,2.4c-0.2,20.9,8.3,27.9,8.3,27.9 c18.6,12.5,34.7-0.6,38.6-5c3.9-4.4,0.7-17.9,9.9-18.9s10.8,15,13.4,17.4s27.6,14,37.5-3.1C206.1,87.7,198.1,74.3,198.1,74.2 L198.1,74.2z M131.7,95c-0.4,7.5-2.2,17-16.7,18s-18.8-5.2-19.1-18.6c0,0,2.9-6.7,16.6-8.1S132.1,87.4,131.7,95z M179.3,107.2 c-14.3,2.1-18.2-6.7-20.2-14s3.1-11,16.8-12.7c13.7-1.6,18,4.3,18,4.3C196.5,98,193.6,105,179.3,107.2L179.3,107.2z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.1,117.5c-0.5,3.4,0.9,6.8,3.6,9c2.6,2,6.1,2.8,9.3,2.3c1.9-0.3,3.4-1.2,4.6-2.7 c0.6-0.8,0.1-2.1-0.6-2.5c-0.9-0.5-1.9-0.2-2.5,0.7c0.2-0.3-0.2,0.2-0.2,0.2c-0.1,0.1-0.4,0.3-0.1,0.1 c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.4,0.2-0.1,0.1c-0.3,0.1-0.7,0.2-1,0.3c-0.1,0-0.7,0.1-0.3,0.1c-0.1,0-0.3,0-0.5,0 c-0.4,0-0.7,0-1.1,0c-0.2,0-0.4,0-0.7-0.1c-0.4,0,0.2,0.1-0.2,0s-0.8-0.2-1.2-0.3c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.2-0.1-0.1,0c0.1,0.1,0.1,0-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.5-0.3 s-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c0.1,0.1,0.1,0.1,0,0c-0.3-0.2-0.6-0.5-0.8-0.8c-0.1-0.1-0.4-0.5-0.2-0.2 c-0.1-0.2-0.2-0.3-0.3-0.5s-0.2-0.3-0.3-0.5c0-0.1-0.3-0.5-0.2-0.4s-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.4-0.2-0.6 s-0.1-0.4-0.1-0.6c0.1,0.4,0-0.2,0-0.3c0-0.2,0-0.4,0-0.6c0-0.1,0.1-0.8,0-0.4c0.1-0.9-0.2-2-1.3-2.2 C132.5,116,131.3,116.5,131.1,117.5L131.1,117.5L131.1,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.9,126.8c3.2,2.5,8,2.3,11.3,0.1s5-6.3,4.4-10.4c-0.1-0.9-1.4-1.5-2.2-1.3c-1,0.3-1.4,1.2-1.3,2.2 c-0.1-0.4,0,0.2,0,0.3c0,0.2,0,0.4,0,0.6s0,0.3,0,0.5c0,0.1-0.1,0.5,0,0.2c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.2-0.1,0.3-0.1,0.5 c0,0.1-0.2,0.5-0.1,0.2c-0.1,0.3-0.3,0.7-0.5,1c-0.1,0.1-0.2,0.3-0.3,0.4s-0.3,0.4-0.1,0.2c-0.2,0.3-0.5,0.6-0.8,0.8 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.2,0.1,0,0c-0.1,0.1-0.1,0.1-0.2,0.1c-0.3,0.2-0.6,0.4-0.9,0.6c0,0-0.5,0.2-0.2,0.1 c-0.2,0.1-0.4,0.1-0.5,0.2c-0.3,0.1-0.7,0.2-1,0.3c-0.2,0-0.3,0.1-0.5,0.1c0.4-0.1-0.2,0-0.3,0c-0.4,0-0.7,0-1.1,0 c-0.2,0-0.3,0-0.5,0c0.4,0-0.2,0-0.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.3c0.3,0.1-0.2-0.1-0.2-0.1c-0.1,0-0.6-0.4-0.4-0.2 c-0.7-0.6-1.8-0.8-2.6,0C145.3,124.9,145.1,126.2,145.9,126.8L145.9,126.8L145.9,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145,119.7c-0.2,1.5-0.2,3,0,4.5c0,0.2,0,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.8,0.6,1.3,0.5 s0.9-0.2,1.3-0.5c0.3-0.3,0.6-0.8,0.5-1.3c-0.2-1.5-0.2-3,0-4.5c0.1-0.4-0.2-1-0.5-1.3s-0.8-0.6-1.3-0.5s-0.9,0.2-1.3,0.5 l-0.3,0.4C145.1,119.1,145,119.4,145,119.7L145,119.7L145,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M156.4,113.1c0.2,3.6-6,8.8-9.1,9c-3.3,0.2-9.7-4.7-9.8-8c-0.2-4.3,5.8-5.9,9.2-6.1 C150,107.7,156.2,109.4,156.4,113.1L156.4,113.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.6,111.1c0,0-8.2-2.1-14.6,1.7c0,0,8.2-3.9,14.6,0.3C153.7,113.1,154.8,112.2,153.6,111.1 L153.6,111.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109711078342705020280000014224872812405347258_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.2989,
    y1: 505.6758,
    x2: 197.7,
    y2: 505.6758,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#462A5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#482E5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#4F3B5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#584B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D1E1C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109711078342705020280000014224872812405347258_)"
    },
    d: "M90.6,85.6l-2.3-27.4 c0,0-0.3-6.9,9.2-12.3S130.3,25,130.3,25s7.2-5.8,18.8-1.9s32.5,9.9,32.5,9.9s13,3.8,14,14.9c0.9,11.1,2.1,24.9,2.1,24.9 L90.6,85.6L90.6,85.6z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.9,84.7L96,60.5c0,0-0.3-6,8.1-10.7s29.1-18.1,29.1-18.1s6.4-5,16.6-1.6s28.8,8.6,28.8,8.6 S190.1,42,191,51.6s1.8,21.2,1.8,21.2L97.9,84.7z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.6,59.9c0,0-0.3-6,8.1-10.7s29.1-18.1,29.1-18.1s0.9-0.7,2.6-1.4c-9.4-2.5-15.2,2-15.2,2 s-20.7,13.4-29.1,18.1S96,60.5,96,60.5l1.9,24.1l12.6-3.3L108.6,59.9L108.6,59.9z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M127.9,39l7.2-0.9l7.1,8.8l4.7-10.3l7.2-0.9l3,24.6l-6.8,0.8L148.5,47l-5.1,10.4h-0.1l-7.4-8.8l1.7,14.1 l-6.7,0.8L127.9,39L127.9,39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049906391949229794990000006699220251145560196_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9,
    y1: 524.2483,
    x2: 218.8921,
    y2: 524.2483,
    gradientTransform: "matrix(1 0 0 1 0 -452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#642480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1839"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049906391949229794990000006699220251145560196_)"
    },
    d: "M97.9,84.7c0,0,40.5-18.2,66-20.8 c25.5-2.5,42.7-4.6,49.4-4s7.6,2.9,1.5,5.8c-6.1,2.8-16.9,7.1-16.9,7.1L97.9,84.7z"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M90.6,85.6l110.6,8.3c0,0,0-0.9-0.2-2.9c0,0,1.7-8.4-2.8-16.7l-2-0.1l1.9-1.3 C197.9,72.8,90.6,85.6,90.6,85.6z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxyLogo);
export default __webpack_public_path__ + "static/media/foxy-logo.a966d06cf80521a5f743dce9830899b8.svg";
export { ForwardRef as ReactComponent };